import { createContext } from "react";

const TranslateContext = createContext(null);
const PrintTemplatesContext = createContext(null);

export { TranslateContext, PrintTemplatesContext };
